import Tabs from "../Tabs";
import "./_tabs-columns-bar.scss";

/**
 * The tab strip rendered via PageHeaderBar's `belowComponent`. "Columns"
 * used to share this row, then moved into the table's own toolbarRight
 * (next to Sort by) - this row is tabs-only again, except `rightSlot`,
 * a generic right-aligned escape hatch for whatever control a given page
 * needs to sit beside its tabs (e.g. Plans/Products/Upsell-Downsell's
 * List/Table view SegmentedToggle, per the design). Not Columns-specific
 * on purpose - the next thing that needs this slot won't need a rename.
 * Renders nothing for a page with neither tabs nor a rightSlot (e.g.
 * Roles, Events) rather than an empty row.
 */
const TabsColumnsBar = ({ tabs, activeTab, handleTabClick, tabsVariant = "underline", rightSlot }) => {
  if (!tabs?.length && !rightSlot) return null;
  return (
    <div className="tabs-columns-bar">
      {tabs?.length > 0 ? (
        <Tabs variant={tabsVariant} tabs={tabs} activeTab={activeTab} handleTabClick={handleTabClick} />
      ) : (
        <span />
      )}
      {rightSlot}
    </div>
  );
};

export default TabsColumnsBar;
